import React, { Suspense } from 'react';
import Page, { PageHeader, PageTitle } from 'components/Page';
import Loading from 'components/Loading';

const AdsList = React.lazy(() => import('./Ads'));

function AdsOrder(props) {
  return (
    <Page>
      <PageHeader>
        <PageTitle>لیست سفارش تبلیغات</PageTitle>
      </PageHeader>

      <Suspense fallback={<Loading />}>
        <AdsList {...props} />
      </Suspense>
    </Page>
  );
}

export default AdsOrder;
